import { Info } from 'lucide-react';
import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@shigo-ui/ui';

export function TailoredSupplyInfoList({ label, values }: { label: string; values: string[] }) {
  if (!values.length) return <span>-</span>;
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="text-muted-foreground hover:text-foreground h-7 w-7"
          aria-label={label}
        >
          <Info className="h-3.5 w-3.5" aria-hidden="true" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-80 whitespace-pre-wrap">
        {values.join(', ')}
      </TooltipContent>
    </Tooltip>
  );
}
